import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';

import { AlertBarComponent } from './alert-bar/alert-bar.component';
import { ReportErrorDialogComponent } from './report-error-dialog/report-error-dialog.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
  declarations: [AlertBarComponent, ReportErrorDialogComponent],
  imports: [
    CommonModule,
    InlineSVGModule,
    TranslocoModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
  ],
  exports: [AlertBarComponent],
})
export class SharedFeatureModulesAlertModule {}
